/**
 * Created by Sergii on 01.10.2018.
 */
import {UserActions} from '../const/ActionsConst';
import {MessageBoxTypes} from "../const/ActionsConst";
import * as UserDetailsActions from "./UserDetailsActions";
import * as UsersTableActions from "./UsersTableActions";

export const showMessageBoxBasedOnData = (type, show, header, text, confirmText, cancelText, size = 'small', data, callback) => ({
    type: UserActions.SHOW_MESSAGE_BOX_BASED_ON_DATA,
    messageBox: {
        type,
        show,
        header,
        text,
        confirmText,
        cancelText,
        size,
        data,
        callback,
    }
});

export const showMessageBox = (show, type, size = 'small') => ({
    type: UserActions.SHOW_MESSAGE_BOX,
    messageBox: {
        type: type,
        show: show,
        size: size
    }
});

export const messageBoxConfirmed = (type, data) => {
    return (dispatch,getState) => {
        dispatch(showMessageBox(false));

        switch (type) {
            case MessageBoxTypes.DELETE_AMBRY_ID:
                dispatch(UserDetailsActions.deleteAmbryPortID(data.id));
                break;
            case MessageBoxTypes.DELETE_USER:
                dispatch(UsersTableActions.deleteUser());
                break;
            case MessageBoxTypes.DELETE_MULTIPLE_USERS:
                dispatch(UsersTableActions.deleteUsers());
                break;
            case MessageBoxTypes.DELETE_SECURITY_CLASS:
                dispatch(UserDetailsActions.deleteSecurityClass(data.id));
                break;
            case MessageBoxTypes.DELETE_PROFILE_FORMATS:
                dispatch(UserDetailsActions.deleteProfiles(data.formats));
                break;
        }
    }
};

export const containsSpecialCharacters = (name) => {
    let format = /[^A-Za-z0-9_-]/; //allow letter, digit, underscore or dash
    return format.test(name);
}

